export const INIT_MAP_OPTION = {
  center: new naver.maps.LatLng(37.50439823071351, 126.95660644992438),
  zoom: 18,
  minZoom: 14,
  baseTileOpacity: 1,
  background: 'white',
  tileSpare: 2,
  mapDataControl: false,
};
